<template>
  <div>
    <div class="top tournament-header">

    <!-- TOURNAMENT HERO -->
    <div class="tournament-hero">

        <div class="hero-course-image">
        <b-img
            v-if="tmparams.course_image_file_1"
            class="courseImg"
            :src="
            config.VUE_APP_PLAYER_IMAGE +
            'courses/' +
            seasonCode +
            '/' +
            tmparams.course_code +
            '/' +
            tmparams.course_image_file_1
            "
        ></b-img>

        <b-img
            v-else
            class="courseImg"
            src="https://ocs-sport.ams3.cdn.digitaloceanspaces.com/let_new/2020/05/sliderdummycourse.png"
        ></b-img>
        </div>

        <div class="hero-content">

        <div class="hero-meta">
<!-- 
            <div
            class="hero-sponsor"
            v-if="data.event_sponsor_logo && data.event_sponsor_logo.length"
            >
            <span class="hero-label">Presented by</span>

            <b-img
                v-if="$route.query.code == '1001' || $route.query.code == '1923'"
                class="hero-sponsor-logo"
                :src="data.event_sponsor_logo"
            ></b-img>

            <b-img
                v-else-if="web_sponsor !== ''"
                class="hero-sponsor-logo"
                :src="web_sponsor"
            ></b-img>

            <b-img
                v-else
                class="hero-sponsor-logo"
                :src="data.event_sponsor_logo"
            ></b-img>
            </div>

            <div class="hero-event-details">
            <span class="hero-label">Event dates</span>
            <strong>{{ data.tourn_dates }}</strong>
            </div> -->

        </div>

        <div class="hero-title">
            <h1>{{ data.full_name }}</h1>
            <h2>{{ courseName }}</h2>
            <span class="hero-label">Event dates</span>
            <strong>{{ data.tourn_dates }}</strong>
        </div>

        </div>

    </div>


    <!-- REPORTS AND COURSE LEGEND -->
    <div class="report-tools">

        <div class="report-panel">

        <div class="report-icon">
            <b-icon icon="file-earmark-text"></b-icon>
        </div>

        <div class="report-selector">

            <label>Select Report</label>

            <b-dropdown
            v-if="
                tmparams.reports &&
                Array.isArray(tmparams.reports.reports_entry)
            "
            :text="title"
            class="dropdownReport modern-report-dropdown"
            >

            <template v-if="data.bball_team == 'Y'">

                <b-dropdown-item
                v-for="(reports, index) in filterReport"
                :key="index"
                @click="changeReport(reports)"
                v-show="
                    reports.report_title.indexOf('Net') != -1 ||
                    reports.report_title.includes('Draw') ||
                    reports.report_title.includes('Entries') ||
                    reports.report_title.includes('Result')
                "
                >
                {{ reports.report_title }}
                </b-dropdown-item>

            </template>

            <template v-else>

                <b-dropdown-item
                v-for="(reports, index) in filterReport"
                :key="index"
                @click="changeReport(reports)"
                >
                {{ reports.report_title }}
                </b-dropdown-item>

            </template>

            </b-dropdown>

        </div>

        </div>


        <div
        v-if="
            tmparams.multi_course === 'Y' &&
            tmparams.courses &&
            tmparams.courses.courses_entry
        "
        class="course-legend"
        >

        <span class="legend-heading">
            <b-icon icon="flag-fill"></b-icon>
            Courses
        </span>

        <span
            class="legend-item"
            v-for="(multi, index) in tmparams.courses.courses_entry"
            :key="index"
        >
            <span
            class="legend-dot"
            :class="multi.course_X_colour"
            ></span>

            <span class="legend-name">
            {{ multi.course_X_id }}
            </span>
        </span>

        </div>

    </div>

    </div>

    <!-- change in tournaments -->
    <!-- <template v-if="data.full_name.includes('Aramco')">
      <div>
        <b-container class="reportPad">
          <b-dropdown
            :text="'List of Tournaments'"
            class="dropdownReport"
          >
            <template v-if="Array.isArray(reportListings)">
              <b-dropdown-item
                v-on:click="changeTournament"
                v-for="(reports, index) in reportListings"
                :key="index"
                :value="reports.code"
                >
                  <template>
                    {{ reports.name }}
                  </template>
              </b-dropdown-item>
            </template>
            <template v-else>
              <b-dropdown-item
                v-on:click="changeTournament"
                :value="reportListings.code"
                >
                  <template>
                    {{ reportListings.full_name }}
                  </template>
              </b-dropdown-item>
            </template>
          </b-dropdown>
        </b-container>
      </div>
    </template>
    <template v-else>
      <div class="reportPad" >
        <b-container>
        </b-container>
      </div>
    </template> -->
    <!-- change in tournaments above -->

    <div class="mid">
      <div>
        <div class="reports">
          <div
            class="mainNonScores"
            v-if="
              this.currentReport.indexOf('tmentry') !== -1 ||
                this.currentReport.indexOf('tmdraw') !== -1 ||
                this.currentReport.indexOf('tmresult') !== -1 ||
                this.currentReport.indexOf('tmtsum') !== -1 ||
                this.currentReport.indexOf('tmoomt') !== -1
            "
          >
            <ReportTable
              :data="data"
              :tmparams="tmparams"
              :code="data.code"
              :season="data.season"
              :home="home"
              :previousData="previousData"
              :title="title"
              :config="config"
              :team="teamEvent"
              :match="tmparams.match_play"
              :bbTeamEvent="tmparams.bball_team"
              :showGender="showGender"
              :Stableford="data.stableford"
              :roundsP="roundsP"
              :show_info_web="show_info_web"
              :hide_score_card="hide_score_card"
            />
          </div>
          <div
            class="main"
            v-else-if="this.currentReport.indexOf('tmscore') !== -1"
          >
            <template v-if="data.match_play == 'Y'">
              <ReportTable
                :data="data"
                :previousData="previousData"
                :home="home"
                :title="title"
                :config="config"
                :team="teamEvent"
                :match="tmparams.match_play"
                :bbTeamEvent="tmparams.bball_team"
                :RTCDS="tmparams.live_oom"
                :code="data.code"
                :season="data.season"
                :showGender="showGender"
                :Stableford="Stableford"
                :show_info_web="show_info_web"
                :hide_score_card="hide_score_card"
                :reportChange="reportChange"
                :tmparams="tmparams"
              />
            </template>
            <template v-else>
              <b-tabs content-class="mt-3">
                <b-tab
                  title="Leaderboard"
                  active
                  title-item-class="hideLeadertab"
                >
                  <ReportTable
                    :data="data"
                    :previousData="previousData"
                    :home="home"
                    :title="title"
                    :config="config"
                    :team="teamEvent"
                    :match="tmparams.match_play"
                    :bbTeamEvent="tmparams.bball_team"
                    :RTCDS="tmparams.live_oom"
                    :code="data.code"
                    :season="data.season"
                    :showGender="showGender"
                    :Stableford="Stableford"
                    :show_info_web="show_info_web"
                    :hide_score_card="hide_score_card"
                    :reportChange="reportChange"
                    :tmparams="tmparams"
                  />
                </b-tab>
                <b-tab title="Hole-by-Hole" title-item-class="hideHBH">
                  <HBH
                    :tabs="tabs"
                    :data="data"
                    :scores="data.scores.scores_entry"
                    :previousData="previousData"
                    :config="config"
                    :team="teamEvent"
                    :bbTeamEvent="tmparams.bball_team"
                    :showGender="showGender"
                    :Stableford="Stableford"
                    :show_info_web="show_info_web"
                    :hide_score_card="hide_score_card"
                    :tmparams="tmparams"
                  />
                </b-tab>
              </b-tabs>
            </template>
          </div>
          <div
            class="main"
            v-else-if="this.currentReport.indexOf('tmlsmon') !== -1"
          >
            <template v-if="data.match_play == 'Y'">
              <ReportTable
                :data="data"
                :previousData="previousData"
                :home="home"
                :title="title"
                :config="config"
                :team="teamEvent"
                :match="tmparams.match_play"
                :RTCDS="tmparams.live_oom"
                :bbTeamEvent="tmparams.bball_team"
                :code="data.code"
                :season="data.season"
                :showGender="showGender"
                :Stableford="Stableford"
                :show_info_web="show_info_web"
                :hide_score_card="hide_score_card"
                :tmparams="tmparams"
              />
            </template>
            <template v-else>
              <b-tabs content-class="mt-3 matt">
                <b-tab
                  title="Live Scoring"
                  active
                  title-item-class="hideLeadertab"
                >
                  <ReportTable
                    :data="data"
                    :previousData="previousData"
                    :home="home"
                    :title="title"
                    :config="config"
                    :team="teamEvent"
                    :match="tmparams.match_play"
                    :RTCDS="tmparams.live_oom"
                    :bbTeamEvent="tmparams.bball_team"
                    :code="data.code"
                    :season="data.season"
                    :showGender="showGender"
                    :Stableford="Stableford"
                    :show_info_web="show_info_web"
                    :hide_score_card="hide_score_card"
                    :reportChange="reportChange"
                    :tmparams="tmparams"
                  />
                </b-tab>
                <b-tab
                  title="Hole by Hole"
                  class="hbhmob"
                  title-item-class="hideHBH"
                >
                  <HBH
                    :tabs="tabs"
                    :data="data"
                    :scores="data.scores.scores_entry"
                    :previousData="previousData"
                    :config="config"
                    :team="teamEvent"
                    :bbTeamEvent="tmparams.bball_team"
                    :showGender="showGender"
                    :Stableford="Stableford"
                    :show_info_web="show_info_web"
                    :hide_score_card="hide_score_card"
                    :tmparams="tmparams"
                  />
                </b-tab>
              </b-tabs>
            </template>
          </div>
        </div>
      </div>
    </div>
    <div
      :class="{ colorMess: data.play_suspended == 'Y' }"
      class="livemessage"
      v-if="livemessage === 'Y' && livemessageText.length"
    >
      <span v-if="data.play_suspended == 'Y' && livemessage == 'N'"
        >Play Suspended</span
      >
      <span v-else>{{ livemessageText }}</span>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import ReportTable from "@/components/lastetreportTable.vue";
import HBH from "@/ocs/latest/scores/hole-by-hole/components/hbh.vue";

export default {
  name: "Latest",

  components: {
    ReportTable,
    HBH,
  },

  props: ["config", "showGender", "Stableford"],

  data() {
    return {
      data: [],
      previousData: [],
      tmparams: {},
      reports: [],
      drop: "drop",
      home: false,
      tabs: true,
      title: "",
      tournCode: "",
      web_sponsor: "",
      reportChange: false,
      showChangeReports: localStorage.getItem("showTournamanet"),
      reportListings: [],
      upcode: "",
      seasonCode: "",
      TournCode: "",

      currentReport: "",
      currentTitle: "",

      show_info_web: "",
      hide_score_card: "",
      livemessage: "",
      livemessageText: "",
      courseName: "",
      roundsP: ""
    };
  },

  methods: {
    changeTournament(event) {
      const code = event.target.getAttribute("value");

      this.tCode = code;

      const url =
        process.env.VUE_APP_TIC_BASE +
        this.seasonCode +
        "/" +
        this.seasonCode +
        "-" +
        code +
        "-tmticx.json?randomadd=" +
        new Date().getTime();

      return axios.get(url).then(response => {
        this.data = response.data;
        this.tmparams = response.data;

        const entries = response.data.reports.reports_entry;

        const reportArray = Array.isArray(entries)
          ? entries
          : entries
            ? [entries]
            : [];

        this.reportsChange = reportArray.slice(-3);

        if (this.reportsChange.length) {
          this.currentReport = this.reportsChange[0].report_url;
          this.currentTitle = this.reportsChange[0].report_title;
          this.title = this.currentTitle;
        }

        this.reportListings = JSON.parse(
          localStorage.getItem("currData")
        );

        if (
          this.reportListings &&
          this.reportListings.code == this.tCode
        ) {
          this.reportListings = JSON.parse(
            localStorage.getItem("PastTourns")
          );
        } else {
          this.reportListings = JSON.parse(
            localStorage.getItem("currData")
          );
        }

        this.switchReports();
      });
    },

    switchReports() {
      axios
        .get(this.reportTitle)
        .then(response => {
          this.data = response.data;
        })
        .catch(error => {
          console.error("Error switching report:", error);
        });
    },

    changeReport(report) {
    this.currentReport = report.report_url;
    this.currentTitle = report.report_title;
    this.title = report.report_title;

    axios
        .get(this.reportTitle)
        .then(response => {
        this.data = response.data;
        })
        .catch(error => {
        console.error("Error loading report:", error);
        });
    },

    updateStuff() {
      if (!this.currentReport) return;

      axios
        .get(this.reportTitle)
        .then(response => {
          this.data = response.data;

          return axios.get(
            process.env.VUE_APP_TIC_BASE +
              this.seasonCode +
              "/" +
              this.seasonCode +
              "-" +
              this.TournCode +
              "-tmticx.json?randomadd=" +
              new Date().getTime()
          );
        })
        .then(response => {
          this.tmparams = response.data;
          this.reports = response.data.reports;
        })
        .catch(error => {
          console.error("Error updating tournament:", error);
        });
    }
  },

  computed: {
    filterReport() {
      const entries =
        this.tmparams &&
        this.tmparams.reports &&
        this.tmparams.reports.reports_entry;

      const reportArray = Array.isArray(entries)
        ? entries
        : entries
          ? [entries]
          : [];

      return reportArray.filter(report => {
        if (!report || !report.report_title) return false;

        return (
          report.report_title.includes("Tournament Entries") ||
          report.report_title.includes("Draw") ||
          report.report_title.includes("Score") ||
          report.report_title.includes("Final Result")
        );
      });
    },

    filterExemptions() {
      const entries =
        this.tmparams &&
        this.tmparams.reports &&
        this.tmparams.reports.reports_entry;

      const reportArray = Array.isArray(entries)
        ? entries
        : entries
          ? [entries]
          : [];

      return reportArray.filter(report => {
        if (!report || !report.report_title) return false;

        const title = report.report_title;

        return !(
          title.includes("Tournament Entries") ||
          title.includes("Round 1 Draw") ||
          title.includes("Round 2 Draw") ||
          title.includes("Round 3 Draw") ||
          title.includes("Round 4 Draw") ||
          title.includes("Round 5 Draw") ||
          title.includes("Round 6 Draw") ||
          title.includes("Round 1 Scores Only") ||
          title.includes("Round 2 Scores Only") ||
          title.includes("Round 3 Scores Only") ||
          title.includes("Round 4 Scores Only") ||
          title.includes("Round 5 Scores Only") ||
          title.includes("Round 6 Scores Only") ||
          title.includes("Round 2 Scoreboard") ||
          title.includes("Round 3 Scoreboard") ||
          title.includes("Round 4 Scoreboard") ||
          title.includes("Round 5 Scoreboard") ||
          title.includes("Round 6 Scoreboard") ||
          title.includes("Final Result")
        );
      });
    },

    teamEvent() {
      return this.data && this.data.team_scores !== undefined
        ? "Y"
        : "N";
    },

    bballTeamEvent() {
      return this.data && this.data.bball_team == "Y"
        ? "Y"
        : "N";
    },

    reportTitle() {
      if (!this.currentReport) return "";

      let url = "";
      const report = this.currentReport;

      if (report.indexOf("tmentry") !== -1) {
        url =
          process.env.VUE_APP_TIC_BASE +
          this.seasonCode +
          "/" +
          this.seasonCode +
          "-" +
          this.TournCode +
          "-entry-entries.json?randomadd=" +
          new Date().getTime();

      } else if (report.indexOf("tmscore") !== -1) {
        const subRep = report.lastIndexOf("params=") + 7;
        const indNext = report.indexOf("~", subRep);

        const repParams = report.substring(
          subRep,
          indNext !== -1 ? indNext : undefined
        );

        if (repParams && repParams.indexOf(".cgi") < 0) {
          url =
            process.env.VUE_APP_TIC_BASE +
            this.seasonCode +
            "/" +
            this.seasonCode +
            "-" +
            this.TournCode +
            "-scores-" +
            repParams +
            ".json?randomadd=" +
            new Date().getTime();
        } else {
          url =
            process.env.VUE_APP_TIC_BASE +
            this.seasonCode +
            "/" +
            this.seasonCode +
            "-" +
            this.TournCode +
            "-scores-latest.json?gt=y&randomadd=" +
            new Date().getTime();
        }

      } else if (report.indexOf("tmlsmon") !== -1) {
        url =
          process.env.VUE_APP_TIC_BASE +
          this.seasonCode +
          "/" +
          this.seasonCode +
          "-" +
          this.TournCode +
          "-scores-latest.json?gt=y&randomadd=" +
          new Date().getTime();

      } else if (report.indexOf("tmdraw") !== -1) {
        const subRep = report.lastIndexOf("round=") + 6;
        const indNext = report.indexOf("~", subRep);

        const drawRnd = report.substring(
          subRep,
          indNext !== -1 ? indNext : undefined
        );

        url =
          process.env.VUE_APP_TIC_BASE +
          this.seasonCode +
          "/" +
          this.seasonCode +
          "-" +
          this.TournCode +
          "-draw-R" +
          drawRnd +
          "-draw.json?randomadd=" +
          new Date().getTime();

      } else if (report.indexOf("tmresult") !== -1) {
        const subRep = report.lastIndexOf("result=") + 7;
        const indNext = report.indexOf("~", subRep);

        const resNum = report.substring(
          subRep,
          indNext !== -1 ? indNext : undefined
        );

        url =
          process.env.VUE_APP_TIC_BASE +
          this.seasonCode +
          "/" +
          this.seasonCode +
          "-" +
          this.TournCode +
          "-result-result-" +
          resNum +
          ".json?randomadd=" +
          new Date().getTime();

      } else {
        url =
          process.env.VUE_APP_TIC_BASE +
          this.seasonCode +
          "/" +
          this.seasonCode +
          "-" +
          this.TournCode +
          "-result-result-PF.json?randomadd=" +
          new Date().getTime();
      }

      return url;
    }
  },

  created() {
    this.updateInterval = setInterval(this.updateStuff, 120000);
  },

  beforeDestroy() {
    clearInterval(this.updateInterval);
  },

  mounted() {
    axios
      .get(
        process.env.VUE_APP_TIC_BASE +
          "tmticx?randomadd=" +
          new Date().getTime()
      )
      .then(response => {
        this.reports = response.data.reports;
        this.seasonCode = response.data.tm_params.season_code;
        this.TournCode = response.data.code;
        this.tmparams = response.data;

        this.showGender = response.data.show_gender;
        this.Stableford = response.data.stableford;
        this.show_info_web = response.data.tm_params.show_info_web;
        this.hide_score_card = response.data.hide_score_card;
        this.livemessage = response.data.live_message;
        this.livemessageText = response.data.live_scoring_mess;
        this.courseName = response.data.course_name;
        this.roundsP = response.data.rounds_played;
        this.tournCode = response.data.code;
        this.web_sponsor = response.data.web_sponsor_logo;

        this.reportListings = JSON.parse(
          localStorage.getItem("PastTourns")
        );

        if (this.filterReport.length) {
          const selected =
            this.filterReport[this.filterReport.length - 1];

          this.currentReport = selected.report_url;
          this.currentTitle = selected.report_title;
          this.title = selected.report_title;
        }

        return axios.get(this.reportTitle);
      })
      .then(response => {
        if (response) {
          this.data = response.data;
        }
      })
      .catch(error => {
        console.error(
          "Error loading tournament data:",
          error
        );
      });
  }
};
</script>

<style scoped>
/* =========================================
   TOURNAMENT HEADER - FLAT DESIGN
========================================= */

.tournament-header {
  width: 100%;
  margin-bottom: 35px;
  color: #17294d;
}


/* HERO */

.tournament-hero {
  position: relative;
  display: flex;
  min-height: 300px;
  overflow: hidden;
  background: #09264b;
  border-radius: 0;
  box-shadow: none;
}

.hero-course-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 65%;
  height: 100%;
  overflow: hidden;
}

.hero-course-image .courseImg {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.hero-course-image:after {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(
    90deg,
    rgba(5, 30, 62, 0) 0%,
    rgba(5, 30, 62, 0.05) 35%,
    #09264b 100%
  );
}

.hero-content {
    position: relative;
    z-index: 2;
    width: 60%;
    margin-left: 64%;
    padding: 35px 45px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    color: #ffffff;
    margin-bottom: 60px;
}

.hero-meta {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 30px;
}

.hero-sponsor {
  display: flex;
  flex-direction: column;
  max-width: 180px;
}

.hero-event-details {
  display: flex;
  flex-direction: column;
  padding-left: 30px;
  border-left: 1px solid rgba(255,255,255,0.35);
}

.hero-label {
  display: block;
  margin-bottom: 8px;
  color: #d6b45c;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 1.4px;
  text-transform: uppercase;
}

.hero-event-details strong {
  color: #ffffff;
  font-size: 15px;
  font-weight: 600;
  white-space: nowrap;
}

.hero-sponsor-logo {
  max-width: 150px;
  max-height: 55px;
  object-fit: contain;
  object-position: left center;
}

.hero-title {
  margin-top: 25px;
}

.hero-title h1 {
  margin: 0 0 8px;
  color: #ffffff;
  font-size: 36px;
  font-weight: 800;
  line-height: 1.15;
}

.hero-title h2 {
  margin: 0;
  color: #d4deeb;
  font-size: 18px;
  font-weight: 500;
}


/* GOLD ACCENT */

.tournament-hero:after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 4px;
  background: linear-gradient(
    90deg,
    #c99b32,
    #f2d78d,
    #c99b32
  );
  z-index: 3;
}


/* =========================================
   REPORT TOOLS
========================================= */

.report-tools {
  display: flex;
  align-items: center;
  gap: 35px;
  min-height: 105px;
  padding: 22px 5px;
  border-bottom: 1px solid #dce2eb;
}

.report-panel {
  display: flex;
  align-items: center;
  gap: 18px;
  flex: 1;
  min-width: 0;
  padding: 0;
  margin: 0;
  background: transparent;
  border: 0;
  border-radius: 0;
  box-shadow: none;
}

.report-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 44px;
  height: 44px;
  color: #ffffff;
  background: #09264b;
  border-radius: 50%;
  font-size: 20px;
}

.report-selector {
  width: 100%;
  max-width: 450px;
}

.report-selector label {
  display: block;
  margin-bottom: 6px;
  color: #17294d;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.4px;
  text-transform: uppercase;
}

.modern-report-dropdown {
  width: 100%;
}

.modern-report-dropdown > button {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  min-height: 43px;
  padding: 9px 14px;
  color: #263650;
  background: #ffffff;
  border: 1px solid #d5dce7;
  border-radius: 3px;
  font-size: 15px;
  font-weight: 600;
  text-align: left;
  box-shadow: none;
}

.modern-report-dropdown > button:hover,
.modern-report-dropdown > button:focus {
  color: #09264b;
  background: #ffffff;
  border-color: #09264b;
  box-shadow: none;
}

.modern-report-dropdown .dropdown-menu {
  width: 100%;
  padding: 5px;
  border: 1px solid #dce2eb;
  border-radius: 3px;
  box-shadow: 0 5px 15px rgba(0,0,0,0.08);
}

.modern-report-dropdown .dropdown-item {
  padding: 9px 12px;
  color: #35445c;
  font-size: 14px;
}

.modern-report-dropdown .dropdown-item:hover {
  color: #09264b;
  background: #f1f4f8;
}


/* =========================================
   COURSE LEGEND
========================================= */

.course-legend {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;
  padding-left: 30px;
  border-left: 1px solid #dce2eb;
}

.legend-heading {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #17294d;
  font-size: 14px;
  font-weight: 700;
}

.legend-item {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.legend-dot {
  display: inline-block;
  width: 11px;
  height: 11px;
  border-radius: 50%;
}

.legend-name {
  color: #526078;
  font-size: 13px;
  font-weight: 500;
}


/* =========================================
   RESPONSIVE
========================================= */

@media (max-width: 991px) {

  .hero-content {
    padding: 30px;
  }

  .hero-title h1 {
    font-size: 28px;
  }

  .report-tools {
    gap: 20px;
  }

  .course-legend {
    gap: 12px;
    padding-left: 20px;
  }

}

@media (max-width: 767px) {

  .tournament-hero {
    min-height: auto;
    flex-direction: column;
  }

  .hero-course-image {
    position: relative;
    width: 100%;
    height: 180px;
  }

  .hero-course-image:after {
    background: linear-gradient(
      0deg,
      #09264b 0%,
      rgba(9,38,75,0) 65%
    );
  }

  .hero-content {
    width: 100%;
    margin-left: 0;
    padding: 15px 20px 25px;
  }

  .hero-meta {
    justify-content: flex-start;
    flex-wrap: wrap;
    gap: 20px;
  }

  .hero-event-details {
    padding-left: 20px;
  }

  .hero-title {
    margin-top: 25px;
  }

  .hero-title h1 {
    font-size: 25px;
  }

  .hero-title h2 {
    font-size: 16px;
  }

  .report-tools {
    flex-direction: column;
    align-items: stretch;
    gap: 20px;
    padding: 20px 0;
  }

  .report-panel {
    width: 100%;
  }

  .report-selector {
    max-width: none;
  }

  .course-legend {
    padding: 15px 0 0;
    border-left: 0;
    border-top: 1px solid #dce2eb;
  }

}
/* =========================================
   REPORT SELECTOR
========================================= */

.report-panel {
  display: flex;
  align-items: center;
  gap: 25px;
  margin-top: 25px;
  padding: 22px 30px;
  background: #ffffff;
  border: 1px solid #e4e9f1;
  border-radius: 16px;
  box-shadow: 0 4px 18px rgba(20, 35, 65, 0.05);
}

.report-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 65px;
  height: 65px;
  color: #ffffff;
  background: #17294d;
  border-radius: 50%;
  font-size: 26px;
}

.report-selector {
  width: 100%;
  max-width: 650px;
}

.report-selector label {
  display: block;
  margin-bottom: 7px;
  color: #17294d;
  font-size: 17px;
  font-weight: 700;
}

.modern-report-dropdown {
  width: 100%;
}

.modern-report-dropdown > button {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  min-height: 52px;
  padding: 12px 18px;
  color: #263650;
  background: #ffffff;
  border: 1px solid #dce3ee;
  border-radius: 9px;
  font-size: 16px;
  font-weight: 600;
  text-align: left;
  box-shadow: none;
}

.modern-report-dropdown > button:hover,
.modern-report-dropdown > button:focus {
  color: #17294d;
  background: #ffffff;
  border-color: #9aaac4;
  box-shadow: 0 0 0 3px rgba(23, 41, 77, 0.06);
}

.modern-report-dropdown .dropdown-menu {
  width: 100%;
  padding: 7px;
  border: 1px solid #e4e9f1;
  border-radius: 10px;
  box-shadow: 0 8px 25px rgba(20, 35, 65, 0.12);
}

.modern-report-dropdown .dropdown-item {
  padding: 10px 13px;
  color: #35445c;
  border-radius: 6px;
  font-size: 14px;
}

.modern-report-dropdown .dropdown-item:hover {
  color: #17294d;
  background: #f0f3f8;
}


/* =========================================
   MULTI COURSE LEGEND
========================================= */

.course-legend {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 25px;
  margin-top: 25px;
  padding: 17px 25px;
  background: #f5f7fb;
  border: 1px solid #e5eaf2;
  border-radius: 50px;
}

.legend-heading {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #17294d;
  font-size: 16px;
  font-weight: 700;
}

.legend-heading svg {
  font-size: 18px;
}

.legend-item {
  display: inline-flex;
  align-items: center;
  gap: 9px;
}

.legend-dot {
  display: inline-block;
  width: 13px;
  height: 13px;
  border-radius: 50%;
}

.legend-name {
  color: #46546a;
  font-size: 14px;
  font-weight: 500;
}


/* =========================================
   RESPONSIVE
========================================= */

@media (max-width: 991px) {

  .tournament-hero {
    min-height: 250px;
  }

  .hero-course-image {
    width: 45%;
  }

  .hero-content {
    margin-left: 32%;
    padding: 25px;
  }

  .hero-meta {
    gap: 15px;
  }

  .hero-title h1 {
    font-size: 27px;
  }

}

@media (max-width: 767px) {

  .tournament-hero {
    display: flex;
    flex-direction: column;
    min-height: auto;
  }

  .hero-course-image {
    position: relative;
    width: 100%;
    height: 180px;
  }

  .hero-course-image:after {
    display: none;
  }

  .hero-content {
    width: 100%;
    margin-left: 0;
    padding: 20px;
  }

  .hero-meta {
    justify-content: flex-start;
    flex-wrap: wrap;
    gap: 20px;
  }

  .hero-event-details {
    padding-left: 20px;
  }

  .hero-title {
    margin-top: 22px;
  }

  .hero-title h1 {
    font-size: 25px;
  }

  .hero-title h2 {
    font-size: 16px;
  }

  .report-panel {
    gap: 15px;
    padding: 18px;
  }

  .report-icon {
    width: 48px;
    height: 48px;
    font-size: 20px;
  }

  .report-selector label {
    font-size: 14px;
  }

  .modern-report-dropdown > button {
    min-height: 45px;
    font-size: 14px;
  }

  .course-legend {
    gap: 15px;
    padding: 16px 20px;
    border-radius: 12px;
  }

  .legend-heading {
    width: 100%;
  }

}
.reportPad {
  margin-bottom: 50px!important;
}
img.courseLogo.sol {
    max-width: 183px;
    width: 60px;
    max-height: 100px;
}
h3.coursenameFull {
  color: #03477a;
  text-align: center;
  margin-top: 2em;
}
::v-deep .nav-tabs .nav-link {
  border-radius: 0;
  font-weight: 400;
  font-size: 12pt;
  color: #ffffff !important;
  background: #015699;
}
span.nameMulti {
  font-size: 13pt !important;
  margin-top: -4px;
}
span.multiName {
  font-size: 13pt !important;
  font-weight: 400;
}
.course {
  font-size: 13pt;
  font-weight: 400;
}
.colorMess {
  background: red;
  color: white;
  font-weight: 500;
  text-align: center;
  position: fixed;
  bottom: 0;
  width: 100%;
  padding-top: 20px;
  padding-bottom: 20px;
}
.livemessage {
  background: #01477b;
  color: white;
  font-weight: 500;
  text-align: center;
  position: fixed;
  bottom: 0;
  width: 100%;
  padding-top: 20px;
  padding-bottom: 20px;
}
.dropdownReport {
  /* margin-left: 10px; */
}
.main {
  /* padding-top: 4%; */
  padding-top: 0%;
  padding-bottom: 2%;
}
.mainNonScores {
  /* padding-top: 6%; */
  padding-top: 0%;
  padding-bottom: 2%;
}

.multi {
  font-size: 13px !important;
  line-height: 50px;
  color: #0b3f7e;
  padding-bottom: 15px;
}
::v-deep .B {
  color: #333333 !important;
  font-size: 40px !important;
  line-height: 50px !important;
  vertical-align: bottom;
  font-size: 60px !important;
  line-height: 0px !important;
  vertical-align: middle;
  margin-top: -12px;
  display: inline-block;
}
::v-deep .R {
  color: #bb0000 !important;
  font-size: 40px !important;
  line-height: 50px !important;
  vertical-align: bottom;
  font-size: 60px !important;
  line-height: 0px !important;
  vertical-align: middle;
  margin-top: -12px;
  display: inline-block;
}
::v-deep .C {
  color: #0f61ce !important;
  font-size: 40px !important;
  line-height: 50px !important;
  vertical-align: bottom;
  font-size: 60px !important;
  line-height: 0px !important;
  vertical-align: middle;
  margin-top: -12px;
  display: inline-block;
}
::v-deep .nav-link.active {
  color: white !important;
  background-color: #01477b !important;
  width: 100%;
  border-color: #01477b !important;
  height: 100%;
  font-weight: 400;
  font-size: 12pt;
}
.selectRD {
  padding: 2% 1%;
}
.selRep {
  /* padding: 100px 0 50px; */
  /* padding: 100px 0 20px; */
  padding: 50px 0 0px;
  padding-left: 8px;
}
.dropdown {
  /* width: 25%; */
  width: 300px;
}
::v-deep .dropdown-toggle {
  text-align: left;
  background-color: #015699;
  border-radius: 0;
}
::v-deep .dropdown-toggle::after {
  margin-top: 3%;
  float: right;
}
::v-deep .mt-3 {
  margin-top: 0 !important;
}

.top {
  /* padding-top: 50px; */
}

.yellow {
  background-color: #eeb500;
  margin: 0px;
}
.noPad {
  padding: 0;
}
.tourDate {
  color: #ffffff;
  font-weight: 400;
  font-size: 16pt;
  margin-top: 15px;
  margin-bottom: 10px;
}
.tourCourse {
  color: #ffffff;
  font-weight: 400;
  font-size: 15pt;
  color: #ffffff;
  margin-bottom: 50px;
}
.tourInfo {
  margin: auto;
  text-align: center;
}
.over {
  overflow: hidden;
  height: 100%;
}
.courseImg {
  width: 100%;
  height: 100%;
}
.courseLogo {
  max-width: 183px;
  margin-top: 70px;
  width: 140px;
  max-height: 80px;
}
::v-deep .nav-tabs .nav-link {
  border-radius: 0;
  font-weight: 400;
  font-size: 12pt;
  color: #03477a;
}
::v-deep .nav-tabs {
  border-bottom: 0px solid #dee2e6;
}
::v-deep li.nav-item {
  border-top: 1px solid #03477a;
  border-left: 1px solid #03477a;
  border-right: 1px solid #03477a;
  margin-right: 5px;
}
@media only screen and (max-width: 990px) {
  ::v-deep .selRep {
    /* padding: 100px 0 50px; */
    /* padding: 100px 0 20px; */
    padding: 50px 0 0px;
    padding-left: 0;
  }
  ::v-deep .hideHBH {
    display: none;
  }
  ::v-deep .hideLeadertab {
    display: none;
  }
  ::v-deep .courseLogo {
    max-width: 183px;
    margin-top: 10px;
    width: 100px;
    max-height: 80px;
  }
  .tourDate {
    color: #ffffff;
    font-weight: 400;
    font-size: 12pt;
    margin-top: 15px;
    margin-bottom: 10px;
  }
  .tourCourse {
    color: #ffffff;
    font-weight: 400;
    font-size: 9pt;
    color: #ffffff;
    margin-bottom: 20px;
  }
  .dropdown {
    width: 100%;
  }
  .hideMobNew {
    display: none;
  }
  ::v-deep .dropdown-toggle::after {
    margin-top: 1.5%;
    float: right;
  }
  ::v-deep .card-header-pills {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
}
@media only screen and (max-width: 768px) {
  .mobHide {
    display: none;
  }
  ::v-deep .dropdown-toggle::after {
    margin-top: 3.5%;
    float: right;
  }
}

@media only screen and (max-width: 480px) {
  ::v-deep .mobileSlider {
    margin-top: 15px;
  }
  ::v-deep .selRep {
    /* padding: 100px 0 50px; */
    /* padding: 100px 0 20px; */
    padding: 50px 0 0px;
    padding-left: 0;
    /* margin-top: 50px!important; */
    margin-top: 15px !important;
  }
  .sponsor {
    margin-top: 2%;
    width: 35%;
    padding-left: 4%;
  }
  .drop {
    margin-top: -10%;
  }
  .selectRD {
    padding: 2% 4%;
  }
  ::v-deep .top {
    padding-top: 0px !important;
  }
  ::v-deep .selRep {
    /* padding: 100px 0 50px; */
    /* padding: 100px 0 20px; */
    padding: 50px 0 0px;
    padding-left: 0;
  }
}
</style>
